import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const IRemoteAuthorityResolverService = ( createDecorator('remoteAuthorityResolverService'));
var RemoteAuthorityResolverErrorCode;
( (function(RemoteAuthorityResolverErrorCode) {
    RemoteAuthorityResolverErrorCode["Unknown"] = "Unknown";
    RemoteAuthorityResolverErrorCode["NotAvailable"] = "NotAvailable";
    RemoteAuthorityResolverErrorCode["TemporarilyNotAvailable"] = "TemporarilyNotAvailable";
    RemoteAuthorityResolverErrorCode["NoResolverFound"] = "NoResolverFound";
})(
    RemoteAuthorityResolverErrorCode || (RemoteAuthorityResolverErrorCode = {})
));
function getRemoteAuthorityPrefix(remoteAuthority) {
    const plusIndex = remoteAuthority.indexOf('+');
    if (plusIndex === -1) {
        return remoteAuthority;
    }
    return remoteAuthority.substring(0, plusIndex);
}
export { IRemoteAuthorityResolverService, RemoteAuthorityResolverErrorCode, getRemoteAuthorityPrefix };
